import React from 'react';
import PropTypes from 'prop-types';
import GetAppIcon from '@material-ui/icons/GetApp';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';
import { colors, fontSize } from '../../constants/styleConstants';
import { getAcceptFormatsTypesForFiles } from '../../utils/editCommon';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 31,
  },
  addButton: {
    height: '40px',
    display: 'flex',
    border: '1px solid rgba(151, 151, 151, 0.5)',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0 13px',
    fontWeight: 'bold',
    fontSize: fontSize.medium,
  },
}));

const FileInput = ({ onImageUpload, formats, className }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const uploadImage = event => {
    const filename = event.target.files[0].name;
    const file = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsDataURL(document.getElementById('uploadImage').files[0]);
    fileReader.onload = e => {
      if (file) {
        onImageUpload({ filename, content: e.target.result, file });
      }
    };
    fileReader.onloadend = () => {
      document.getElementById('uploadImage').value = '';
    };
  };

  return (
    <div className={classnames(classes.root, className)}>
      <label className={classes.addButton}>
        <input
          hidden
          type="file"
          accept={getAcceptFormatsTypesForFiles('image', formats)}
          id="uploadImage"
          onChange={uploadImage}
        />
        {t(`${TP}.FN_UPLOAD_IMAGE`)}
        <GetAppIcon style={{ color: colors.blueLight, marginLeft: 8 }} />
      </label>
    </div>
  );
};

FileInput.propTypes = {
  onImageUpload: PropTypes.func,
  formats: PropTypes.array,
  className: PropTypes.string,
};

FileInput.defaultProps = {
  onImageUpload: () => {},
  formats: ['jpg'],
  className: '',
};

export default FileInput;
